import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import OrganizationProvider from "./OrganizationProvider";
import store from "./store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <OrganizationProvider>
      <App />
    </OrganizationProvider>
  </Provider>
);
